import { getChildrenItems as apiGetChildrenItems } from '../../../qwanyx-core/api-client';

export async function getChildrenItems(parentId) {
    try {
        // Use the API client instead of direct MongoDB access
        const items = await apiGetChildrenItems(parentId);
        return items;
    } catch (error) {
        console.error("Error fetching items from Qwanyx:", error);
        throw error;
    }
}